import moment from "moment";

const parseDuration = (value) =>
  value.split(",").reduce((duration, part) => {
    const [amount, unit] = part.trim().split(" ");
    duration[unit] = amount;
    return duration;
  }, {});

export const createMomentFormatter = (momentInstance = moment) => {
  return (input, ...operations) => {
    let date;

    if (Array.isArray(input) && typeof input[0] === "string") {
      date = momentInstance(input[0], input[1], true);
    } else if (typeof input === "number" && input.toString().length < 12) {
      date = momentInstance.unix(input);
    } else {
      date = momentInstance(input);
    }

    if (!input || !date.isValid()) {
      console.warn("Could not build a valid `moment` object from input.");
      return input;
    }

    while (operations.length > 0) {
      const method = operations.shift();

      if (method === "add" || method === "subtract") {
        date[method](parseDuration(operations.shift()));
      } else {
        date = date.format(method);
      }
    }

    return date;
  };
};
